import 'slick-carousel';
import 'magnific-popup';

/**
 * @file
 * A JavaScript file for the theme.
 *
 * In order for this JavaScript to be loaded on pages, see the instructions in
 * the README.txt next to this file.
 */
// JavaScript should be made compatible with libraries other than jQuery by
// wrapping it with an "anonymous closure". See:
// - https://drupal.org/node/1446420
// - http://www.adequatelygood.com/2010/3/JavaScript-Module-Pattern-In-Depth
(function (Drupal, $) {

  'use strict';

  let flag = false;

  // To understand behaviors, see https://drupal.org/node/756722#behaviors
  Drupal.behaviors.my_custom_behavior = {
    attach: function (context, settings) {
      if (flag === false) {
        flag = true;
        Drupal.project.popupVideo();
        Drupal.project.zoomGallery();
        Drupal.project.people();
        Drupal.project.search_open();
        Drupal.project.search_close();
      }
    }
  };

  Drupal.project = {};

  /**
   * Function Diaporama gallery
   */
  Drupal.project.zoomGallery = function () {
    $('.diapo-gallery, .js-gallery').each(function () {
      $(this).magnificPopup({
        delegate: 'a',
        type: 'image',
        removalDelay: 300,
        mainClass: 'mfp-fade',
        gallery: {
          enabled: true,
          navigateByImgClick: true,
          preload: [0, 1]
        },
        image: {
          tError: '<a href="%url%">The image #%curr%</a> could not be loaded.'
        }
      });
    });
  };

  /**
   * Function popup video
   */
  Drupal.project.popupVideo = function () {
    $('.video-popup').magnificPopup({
      disableOn: 700,
      type: 'iframe',
      removalDelay: 160
    });
  };

  /**
   * Function show people
   */
  Drupal.project.people = function () {
    console.log('Drupal.project.people');
    $('.paragraph-content').on('click tap', '.b-people figure', function () {
      console.log('click !');
      if ($(this).hasClass('open')) {
        $(this).parent().next('.b-people-details').slideUp(200);
        $(this).removeClass('open');
        $('.listing-people').removeClass('open');
      } else {
        $('.b-people-details').slideUp(200);
        $('.listing-people').removeClass('open');
        $('.b-people figure').removeClass('open');
        $('.listing-people').addClass('open');
        $(this).addClass('open');
        $(this).parent().next('.b-people-details').slideDown(300);
      }
    });

  };

  Drupal.project.search_open = function () {
    $('.js-search').click(function () {
      $('.js-search').attr('aria-expanded', function (index, attr) {
        return attr == 6 ? null : 6;
      });
      $('#header-form-search').toggleClass('visually-hidden');
    });
  }

  Drupal.project.search_close = function () {
    $('.b-search .close').click(function () {
      $(this).hide();
      $('.b-search .loupe').show();
      $('#block-encis-search').hide(200);
    });
  }


  $(document).ready(function () {
    runAnimation();

    /**
     * Bloc slider contenu
     */
    if ($('.slider').length) {
      let $slider = $('.slider');


      $slider.slick({
        dots: true,
        arrows: false,
        speed: 500,
        fade: true,
        cssEase: 'linear',
        autoplay: true
      });
    }

    /**
     * Bloc slider partners
     */
    if ($('.slider-people').length) {
      let $sliderPartners = $('.slider-people .items');
      $sliderPartners.slick({
        infinite: true,
        autoplay: true,
        autoplaySpeed: 5000,
        slidesToShow: 4,
        slidesToScroll: 4,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            }
          }
        ],
      });
    }

    // Accordeons
    $('.paragraph--type--accordeon button').click(function () {
      $(this).toggleClass('open');
      $(this).next('.accordion-data').slideToggle(300);
    });


    // Slider secteurs.
    if ($('.js-carousel .field--name-field-secteurs').length) {
      let $sliderSecteurs = $('.js-carousel .field--name-field-secteurs');
      $sliderSecteurs.slick({
        dots: false,
        arrows: true,
        cssEase: 'linear',
        infinite: false,
        speed: 200,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      });
    }

    // Sliders.
    if ($('.paragraph--type--slider .field--name-field-slider').length) {
      let $sliderSecteurs = $('.paragraph--type--slider .field--name-field-slider');
      $sliderSecteurs.slick({
        dots: false,
        arrows: true,
        cssEase: 'linear',
        infinite: true,
        speed: 200,
        slidesToShow: 2,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      });
    }

    /*$('.field--name-field-secteurs').slick({
      infinite: false,
      slidesToShow: 3,
      slidesToScroll: 1,
      responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    });


    /* Header
  *******************************************************************************/
    if ($('.js-header-sticky').length) {
      $(document).on('resize scroll', function () {

        var header_fixe = $('.js-header-sticky');
        var position_scroll = $(window).scrollTop();
        var height_header = header_fixe.height();

        if (position_scroll >= height_header) {
          header_fixe.addClass('is-sticked', 300);
        } else {
          header_fixe.removeClass('is-sticked', 300);
        }
        //}
      });
    }

    /* GENERAL : Responsive menu
 *******************************************************************************/
    var $btnMenuOpen = $('.js-open-menu');
    var $menu = $('.menu-main');

    $btnMenuOpen.on('click tap', function (e) {
      e.preventDefault();
      $menu.toggleClass('is-visible');
      $('body').toggleClass('no-overflow');
    });

  });

  function runAnimation(event) {
      const animate = new IntersectionObserver(function (entries) {
      let delay = 0

      entries.forEach(function (entry) {

        if (entry.intersectionRatio > 0) {
          if ($(entry.target).prev().hasClass('js-animate-item')) {
            delay += 200
            $(entry.target).css('animation-delay', delay + 'ms');
          } else {
            delay = 0
          }

          setTimeout(() => {
            $(entry.target).addClass('is-visible');
          }, 500)
          setTimeout(() => {
            $(entry.target).addClass('is-finish').css('animation-delay', '').dequeue();
          }, delay + 900)
        }
      });
    });

    $('.js-animate-item').each(function () {
      animate.observe(this);
    });
  }


})(Drupal, jQuery);
